import { useState, useEffect } from "react";
import "./AdminPanel.css";

export default function AdminPanel({ open, onClose }) {
  const [users, setUsers]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    fetch("/api/admin/users", { credentials: "include" })
      .then(r => r.json())
      .then(data => { setUsers(data.users || []); setLoading(false); })
      .catch(() => { setError("Failed to load users"); setLoading(false); });
  }, [open]);

  async function toggleAdmin(user) {
    const action = user.is_admin ? "Remove admin access from" : "Grant admin access to";
    if (!window.confirm(`${action} ${user.email}?`)) return;
    const res  = await fetch(`/api/admin/users/${user.id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ is_admin: !user.is_admin }),
    });
    const data = await res.json();
    if (!res.ok) return alert(data.error);
    setUsers(prev => prev.map(u => u.id === user.id ? { ...u, is_admin: data.user.is_admin } : u));
  }

  async function deleteUser(user) {
    if (!window.confirm(`Delete ${user.email} and all their data? This cannot be undone.`)) return;
    const res  = await fetch(`/api/admin/users/${user.id}`, { method: "DELETE", credentials: "include" });
    const data = await res.json();
    if (!res.ok) return alert(data.error);
    setUsers(prev => prev.filter(u => u.id !== user.id));
  }

  if (!open) return null;

  const totalTodos = users.reduce((s, u) => s + Number(u.total_todos), 0);
  const totalActive = users.reduce((s, u) => s + Number(u.active_todos), 0);

  return (
    <div className="admin-overlay" onClick={onClose}>
      <div className="admin-panel" onClick={e => e.stopPropagation()}>
        <div className="admin-header">
          <h2>Admin</h2>
          <button className="admin-close" onClick={onClose}>✕</button>
        </div>

        <div className="admin-stats">
          <div className="admin-stat">
            <div className="admin-stat-num">{users.length}</div>
            <div className="admin-stat-label">Users</div>
          </div>
          <div className="admin-stat">
            <div className="admin-stat-num">{totalTodos}</div>
            <div className="admin-stat-label">Total Todos</div>
          </div>
          <div className="admin-stat">
            <div className="admin-stat-num">{totalActive}</div>
            <div className="admin-stat-label">Active Todos</div>
          </div>
        </div>

        {loading && <div className="admin-loading">Loading…</div>}
        {error   && <div className="admin-error">{error}</div>}

        {!loading && !error && (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Email</th>
                <th>Joined</th>
                <th>Todos</th>
                <th>Active</th>
                <th>Verified</th>
                <th>Admin</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td className="admin-email">
                    {u.email}
                  </td>
                  <td className="admin-date">
                    {new Date(u.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                  </td>
                  <td className="admin-num">{u.total_todos}</td>
                  <td className="admin-num">{u.active_todos}</td>
                  <td>
                    <span className={"admin-badge" + (u.email_verified || u.is_admin ? " admin-badge-on" : "")}>
                      {u.email_verified || u.is_admin ? "✓" : "Pending"}
                    </span>
                  </td>
                  <td>
                    <button
                      className={"admin-badge" + (u.is_admin ? " admin-badge-on" : "")}
                      onClick={() => toggleAdmin(u)}
                      title={u.is_admin ? "Remove admin" : "Make admin"}
                    >
                      {u.is_admin ? "Admin" : "User"}
                    </button>
                  </td>
                  <td>
                    <button className="admin-delete" onClick={() => deleteUser(u)} title="Delete user">
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
